(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nxt-product-enhancements"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('nxt-product-enhancements')) return;
  class NxtProductEnhancements extends HTMLElement {
    connectedCallback() {
      if (this.connected || !/^\d+$/.test(this.dataset.productId || '')) return;
      this.productForm = document.querySelector(`product-form-component[data-product-id="${this.dataset.productId}"]`);
      this.section = this.productForm?.closest('.shopify-section');
      if (!this.section) return;
      this.connected = true;
      this.state = 'idle';
      try { this.strings = JSON.parse(this.querySelector('[data-nxp-config]').textContent); } catch { this.strings = {}; }
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.section.addEventListener('submit', (event) => this.handleSubmit(event), { capture: true, signal });
      this.section.addEventListener('click', (event) => this.handleClick(event), { capture: true, signal });
      document.addEventListener('cart:update', (event) => this.handleCartUpdate(event), { signal });
      document.addEventListener('cart:error', (event) => this.handleCartError(event), { signal });
      this.section.addEventListener('variant:update', () => this.scheduleSync(), { signal });
      this.section.addEventListener('variant:selected', () => this.scheduleSync(), { signal });
      this.observer = new MutationObserver(() => this.scheduleSync());
      this.observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'hidden', 'aria-hidden', 'class', 'style', 'disabled', 'data-stuck', 'data-variant-available'] });
      this.sync();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.barResizeObserver?.disconnect();
      this.observedBar = null;
      document.body.style.removeProperty('--nxs-purchase-height');
      clearTimeout(this.timeout);
      cancelAnimationFrame(this.frame);
      this.connected = false;
    }

    getForm() { return this.productForm?.querySelector('form'); }

    nativeCanSubmit(form) {
      const target = this.productForm?.querySelector('[ref="addToCartButton"]');
      if (!form || !target || target.disabled || !form.querySelector('input[name="id"]')?.value || !form.checkValidity()) return false;
      const quantity = this.productForm?.querySelector('quantity-selector-component');
      return quantity?.canAddToCart ? quantity.canAddToCart().canAdd === true : true;
    }

    stop(event) { event.preventDefault(); event.stopImmediatePropagation(); }

    handleClick(event) {
      const button = event.target.closest?.('button');
      if (!button) return;
      const sticky = button.matches('.sticky-add-to-cart__button');
      const native = button.matches('[ref="addToCartButton"]') && button.closest('product-form-component') === this.productForm;
      if (!sticky && !native) return;
      if (this.state !== 'idle') { this.stop(event); this.sync(); return; }
      const form = this.getForm();
      if (sticky && form && !form.checkValidity()) { this.stop(event); form.reportValidity(); }
    }

    handleSubmit(event) {
      const form = this.getForm();
      if (event.target !== form) return;
      if (this.state !== 'idle') { this.stop(event); return; }
      if (!this.nativeCanSubmit(form)) return;
      this.state = 'pending';
      this.requestFormId = form.getAttribute('id');
      this.requestVariantId = form.querySelector('input[name="id"]').value;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => this.markUncertain(), 20000);
      this.sync();
    }

    isMatchingEvent(event) {
      return event.target === this.productForm || Boolean(this.requestFormId && event.detail?.sourceId === this.requestFormId);
    }

    handleCartUpdate(event) {
      if (this.state !== 'pending' || !this.isMatchingEvent(event)) return;
      if (event.detail?.data?.didError) { this.markUncertain(); return; }
      clearTimeout(this.timeout);
      this.state = 'idle';
      this.sync();
    }

    handleCartError(event) {
      if (this.state === 'pending' && this.isMatchingEvent(event)) this.markUncertain();
    }

    markUncertain() {
      if (this.state !== 'pending') return;
      clearTimeout(this.timeout);
      this.state = 'uncertain';
      this.sync();
    }

    scheduleSync() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => { this.frame = 0; this.sync(); });
    }

    writeAttribute(element, name, value) {
      if (!element) return;
      if (value === null) { if (element.hasAttribute(name)) element.removeAttribute(name); }
      else if (element.getAttribute(name) !== value) element.setAttribute(name, value);
    }

    statusFor(container) {
      if (!container) return null;
      let status = container.querySelector(':scope > [data-nxp-status]');
      if (!status) {
        const template = this.querySelector('[data-nxp-status-template]');
        if (!template) return null;
        status = template.content.firstElementChild.cloneNode(true);
        container.appendChild(status);
      }
      return status;
    }

    updateBarHeight(bar) {
      const height = Math.ceil(bar.getBoundingClientRect().height);
      if (!Number.isFinite(height) || height < 0) return;
      const value = `${height}px`;
      if (document.body.style.getPropertyValue('--nxs-purchase-height') !== value) document.body.style.setProperty('--nxs-purchase-height', value);
    }

    observeBar(bar) {
      if (this.observedBar === bar) return;
      this.barResizeObserver?.disconnect();
      this.observedBar = bar;
      if (!bar) return;
      this.updateBarHeight(bar);
      this.barResizeObserver = new ResizeObserver(() => {
        if (this.observedBar === bar) this.updateBarHeight(bar);
      });
      this.barResizeObserver.observe(bar);
    }

    sync() {
      this.productForm = this.section.querySelector(`product-form-component[data-product-id="${this.dataset.productId}"]`) || this.productForm;
      const form = this.getForm();
      const sticky = this.section.querySelector('sticky-add-to-cart');
      const bar = sticky?.querySelector('[ref="stickyBar"]');
      this.observeBar(bar);
      const nativeButton = this.productForm?.querySelector('[ref="addToCartButton"]');
      const stickyButton = bar?.querySelector('[ref="addToCartButton"]');
      const blocked = this.state !== 'idle';
      this.writeAttribute(form, 'aria-busy', this.state === 'pending' ? 'true' : null);
      for (const button of [nativeButton, stickyButton]) this.writeAttribute(button, 'aria-disabled', blocked ? 'true' : null);
      const variantId = form?.querySelector('input[name="id"]')?.value || '';
      for (const action of this.section.querySelectorAll('[data-nxs-product-add]')) {
        const disabled = !variantId || !nativeButton || nativeButton.disabled || action.dataset.nxsRequiresSellingPlan === 'true';
        if (action.disabled !== disabled) action.disabled = disabled;
        action.dataset.nxsVariantId = variantId;
      }
      const overlays = document.querySelectorAll('dialog[open], [aria-modal="true"]:not([aria-hidden="true"]), #shopify-pc__banner, #shopify-privacy-banner, .shopify-pc__banner, [data-cookie-banner]');
      const obscured = Array.from(overlays).some((overlay) => {
        if (overlay.hidden || overlay.getAttribute('aria-hidden') === 'true') return false;
        if (overlay.checkVisibility) return overlay.checkVisibility({ checkOpacity: true, checkVisibilityCSS: true });
        const style = getComputedStyle(overlay);
        return overlay.getClientRects().length > 0 && style.visibility !== 'hidden' && style.display !== 'none';
      });
      this.writeAttribute(bar, 'data-nxp-obscured', obscured ? 'true' : 'false');
      if (bar) bar.inert = obscured || bar.dataset.stuck !== 'true' || sticky.dataset.variantAvailable !== 'true';
      for (const container of [this.productForm?.closest('.buy-buttons-block'), bar]) {
        const status = this.statusFor(container);
        if (!status) continue;
        if (status.hidden !== !blocked) status.hidden = !blocked;
        const message = status.querySelector('[data-nxp-message]');
        const text = this.state === 'uncertain' ? this.strings.uncertain : this.state === 'pending' ? this.strings.pending : '';
        if (message && message.textContent !== text) message.textContent = text;
        const link = status.querySelector('[data-nxp-cart]');
        if (link && link.hidden !== (this.state !== 'uncertain')) link.hidden = this.state !== 'uncertain';
      }
    }
  }
  customElements.define('nxt-product-enhancements', NxtProductEnhancements);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nxt-product-information-controller"] && !Shopify.designMode) return;
  try {
    (() => {
  const readDescriptionText = (node) => {
    if (node.nodeType === 3) return node.textContent || '';
    if (node.nodeType !== 1 && node.nodeType !== 11) return '';
    if (node.nodeType === 1 && ['SCRIPT', 'STYLE', 'TEMPLATE'].includes(node.tagName)) return '';
    if (node.tagName === 'BR') return '\n';
    const text = Array.from(node.childNodes).map(readDescriptionText).join('');
    return ['P', 'DIV', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'LI', 'TR'].includes(node.tagName) ? '\n' + text + '\n' : text;
  };

  const parseFacts = (text) => {
    const lines = text.replace(/\u00a0/g, ' ').split(/\r?\n/).map(line => line.replace(/[ \t]+/g, ' ').trim()).filter(Boolean);
    let ambiguousAmount = false;
    const labelled = (label, amount = false) => {
      const values = [];
      for (let index = 0; index < lines.length; index += 1) {
        const match = lines[index].match(label);
        if (!match) continue;
        const value = (match[1] || lines[index + 1] || '').trim();
        if (value && !value.includes(':') && !values.includes(value)) values.push(value);
      }
      if (amount && values.length > 1) ambiguousAmount = true;
      return values.length === 1 ? values[0] : '';
    };
    const pack = labelled(/^Inhalt(?: pro (?:Dose|Doypack|Flasche|Packung))?:\s*(.*)$/i, true);
    const dailyDose = labelled(/^(?:Tagesdosis|Tagesportion):\s*(.*)$/i, true);
    const recommendedDose = labelled(/^(?:Empfohlene Verzehrempfehlung|Verzehrempfehlung):\s*(.*)$/i, true);
    const dose = dailyDose || recommendedDose;
    const flavor = labelled(/^Geschmack:\s*(.*)$/i);
    const explicit = labelled(/^Portionen:\s*(.*)$/i, true);
    const packWithServings = pack.match(/^(.+?)\s+[-–—]\s+(\d+\s+Portionen?)$/i);
    const packAmount = packWithServings ? packWithServings[1] : pack;
    const count = (value) => {
      const match = value.match(/^(\d+)\s+(?:vegane?\s+)?(Kapseln?|Tabletten?|Softgels?|Gummies|Gummis?|Stück)(?:\s*=\s*\d+(?:[,.]\d+)?\s*g|\s*\(\s*\d+(?:[,.]\d+)?\s*g\s*\))?$/i);
      if (!match) return null;
      const number = Number(match[1]);
      if (!Number.isSafeInteger(number) || number < 1 || number > 100000) return null;
      const unit = /^gumm/i.test(match[2]) ? 'gummy' : match[2].toLowerCase().replace(/n$/, '').replace(/s$/, '');
      return { number, unit };
    };
    const measure = (value) => {
      const match = value.match(/^(\d+(?:,\d{1,3}|\.\d{1,2})?)\s*(g|ml)$/i);
      if (!match) return null;
      const number = Math.round(Number(match[1].replace(',', '.')) * 1000);
      return Number.isSafeInteger(number) && number > 0 ? { number, unit: match[2].toLowerCase() } : null;
    };
    const packCount = count(packAmount);
    const dailyCount = count(dose);
    const packQuantity = packCount || measure(packAmount);
    const dailyQuantity = dailyCount || measure(dose);
    const recommendedQuantity = count(recommendedDose) || measure(recommendedDose);
    if (dailyDose && dailyQuantity && recommendedQuantity && (dailyQuantity.unit !== recommendedQuantity.unit || dailyQuantity.number !== recommendedQuantity.number)) ambiguousAmount = true;
    const sameUnit = packQuantity && dailyQuantity && (packQuantity.unit === dailyQuantity.unit || (packCount && dailyCount?.unit === 'stück'));
    const declared = [...new Set([explicit, packWithServings?.[2] || ''].filter(Boolean).map(value => value.replace(/\s+Portionen?$/i, '')))];
    let servings = null;
    let basis = '';
    const explicitMatch = declared.length === 1 && declared[0].match(/^(\d+)$/);
    if (explicitMatch) {
      const value = Number(explicitMatch[1]);
      if (Number.isSafeInteger(value) && value > 0 && value <= 100000) {
        servings = value;
        basis = 'explicit';
      }
    } else if (!declared.length && sameUnit && packQuantity.number % dailyQuantity.number === 0) {
      servings = packQuantity.number / dailyQuantity.number;
      basis = 'daily';
    }
    const conflictingQuantity = packQuantity && dailyQuantity && (!sameUnit || ((packCount || packQuantity.number % dailyQuantity.number === 0) && packQuantity.number / dailyQuantity.number !== servings));
    if (servings && (ambiguousAmount || servings > 100000 || conflictingQuantity)) {
      servings = null;
      basis = '';
    }
    return { pack: pack.length <= 80 ? pack : '', dose, flavor: flavor.length <= 70 ? flavor : '', servings, basis };
  };

  class NxtProductFacts extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const source = this.querySelector('[data-nxp-source]');
      const configNode = this.querySelector('[data-nxp-config]');
      if (!source || !configNode) return;
      try {
        this.config = JSON.parse(configNode.textContent);
        this.facts = parseFacts(readDescriptionText(source.content));
        this.variants = new Map(this.config.variants.map(variant => [String(variant.id), variant]));
        this.formatter = new Intl.NumberFormat(this.config.locale || 'de', { style: 'currency', currency: this.config.currency });
      } catch (_) { return; }
      this.ready = true;
      this.setField('pack', this.facts.pack);
      this.setField('flavor', this.facts.flavor);
      this.setField('servings', this.facts.servings);
      this.updatePrice(this.config.selectedId);
      const basis = this.querySelector('[data-nxp-basis]');
      if (basis && this.facts.servings && this.facts.basis) {
        basis.textContent = this.config.strings[this.facts.basis].replace('{servings}', this.facts.servings).replace('{dose}', this.facts.dose);
        basis.hidden = false;
      }
      this.hidden = !this.facts.pack && !this.facts.flavor && !this.facts.servings;
      this.onVariant = (event) => {
        const detail = event.detail || {};
        const productId = detail.data?.productId;
        if (productId && String(productId) !== String(this.config.productId)) return;
        const id = detail.resource?.id;
        if (!productId && !this.variants.has(String(id))) return;
        this.updatePrice(id);
      };
      document.addEventListener('variant:update', this.onVariant);
    }
    disconnectedCallback() {
      document.removeEventListener('variant:update', this.onVariant);
      this.ready = false;
    }
    setField(name, value) {
      const field = this.querySelector('[data-nxp-' + name + ']');
      if (!field) return;
      field.hidden = value === null || value === undefined || value === '';
      const content = field.querySelector('dd');
      if (content) content.textContent = field.hidden ? '' : String(value);
    }
    updatePrice(id) {
      const variant = this.variants.get(String(id));
      const price = Number(variant?.price);
      const value = this.facts.servings && variant && Number.isFinite(price) && price >= 0 ? this.formatter.format(price / this.facts.servings / 100) : '';
      this.setField('price', value);
    }
  }

  class NxtProductInformation extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.querySelectorAll('.nxp-info__body p').forEach(paragraph => {
        const text = (paragraph.textContent || '').trim();
        if ((!text || text === '⸻') && !paragraph.querySelector('img,video,iframe,svg')) paragraph.remove();
      });
      this.onClick = (event) => {
        const link = event.target.closest('a[href^="#"]');
        if (!link || !this.contains(link)) return;
        this.openTarget(link.hash);
      };
      this.onHash = () => this.openTarget(window.location.hash);
      this.addEventListener('click', this.onClick);
      window.addEventListener('hashchange', this.onHash);
      this.onHash();
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      window.removeEventListener('hashchange', this.onHash);
      this.ready = false;
    }
    openTarget(hash) {
      if (!hash || hash.length < 2) return;
      let id;
      try { id = decodeURIComponent(hash.slice(1)); } catch (_) { return; }
      const target = document.getElementById(id);
      if (target && this.contains(target) && target.tagName === 'DETAILS') target.open = true;
    }
  }
  if (!customElements.get('nxt-product-facts')) customElements.define('nxt-product-facts', NxtProductFacts);
  if (!customElements.get('nxt-product-information')) customElements.define('nxt-product-information', NxtProductInformation);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nxt-set-controller"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('nxt-set-builder')) return;

  const string = (value, limit = 1200) => typeof value === 'string' ? value.slice(0, limit) : '';
  const parse = (value, fallback) => {
    try { return JSON.parse(value); } catch { return fallback; }
  };
  const node = (tag, className, value) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (value !== undefined) element.textContent = value;
    return element;
  };
  const url = (value, kind = 'product') => {
    if (typeof value !== 'string' || !value) return '';
    try {
      const target = new URL(value, location.href);
      if (!['https:', 'http:'].includes(target.protocol) || target.username || target.password) return '';
      if (kind === 'image') {
        const cdn = target.hostname === 'cdn.shopify.com' || target.hostname === 'shopifycdn.com' || target.hostname.endsWith('.shopifycdn.com');
        return target.origin === location.origin || (target.protocol === 'https:' && cdn) ? target.href : '';
      }
      if (target.origin !== location.origin) return '';
      const paths = {
        product: /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[a-z0-9_-]+\/?$/i,
        cart: /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart\/?$/i,
        add: /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart\/add\.js$/i
      };
      return paths[kind]?.test(target.pathname) ? target.href : '';
    } catch { return ''; }
  };

  class NxtSetBuilder extends HTMLElement {
    static storageKey = 'nxt-set-selection-v1';

    static restore(raw, variants) {
      const selection = new Map();
      if (!raw) return { selection, uncertain: false, inspected: false, pruned: false };
      const saved = typeof raw === 'string' && raw.length <= 50000 ? parse(raw, null) : null;
      if (!saved || saved.version !== 1 || !Array.isArray(saved.items)) return { selection, uncertain: true, inspected: false, pruned: true };
      let pruned = saved.items.length > 200;
      for (const item of saved.items.slice(0, 200)) {
        const id = typeof item?.id === 'string' ? item.id : '';
        const entry = variants.get(id);
        const quantity = entry ? NxtSetBuilder.validQuantity(item.quantity, entry.variant) : null;
        if (!entry || !entry.variant.available || entry.product.requiresSellingPlan || quantity === null || selection.has(id)) {
          pruned = true;
          continue;
        }
        selection.set(id, quantity);
      }
      return { selection, uncertain: saved.state !== 'editing', inspected: saved.inspected === true, pruned };
    }

    static quantityBounds(variant) {
      const min = Number.isSafeInteger(variant?.min) && variant.min > 0 ? variant.min : 1;
      const increment = Number.isSafeInteger(variant?.increment) && variant.increment > 0 ? variant.increment : 1;
      const declaredMax = variant?.max === null || variant?.max === undefined ? Infinity : Number(variant.max);
      const ceiling = Math.min(Math.max(99, min), Number.isSafeInteger(declaredMax) && declaredMax >= 0 ? declaredMax : declaredMax === Infinity ? Infinity : 0);
      const max = ceiling < min ? 0 : min + Math.floor((ceiling - min) / increment) * increment;
      return { min, max, increment };
    }

    static validQuantity(value, variant) {
      if (value === '' || value === null || value === undefined || typeof value === 'boolean') return null;
      const quantity = Number(value);
      const { min, max, increment } = NxtSetBuilder.quantityBounds(variant);
      return Number.isSafeInteger(quantity) && quantity >= min && quantity <= max && (quantity - min) % increment === 0 ? quantity : null;
    }

    static payload(selection, variants) {
      const items = [];
      for (const [id, rawQuantity] of selection) {
        const entry = variants.get(id);
        if (!entry || !/^\d+$/.test(id) || !entry.variant.available || entry.product.requiresSellingPlan) return null;
        const quantity = NxtSetBuilder.validQuantity(rawQuantity, entry.variant);
        if (quantity === null) return null;
        items.push({ id, quantity });
      }
      return items.length ? { items } : null;
    }

    static total(selection, variants) {
      let cents = 0;
      for (const [id, quantity] of selection) {
        const entry = variants.get(id);
        if (!entry || NxtSetBuilder.validQuantity(quantity, entry.variant) === null) return null;
        cents += entry.variant.price * quantity;
        if (!Number.isSafeInteger(cents)) return null;
      }
      return cents;
    }

    static errorDescription(data) {
      if (!data || typeof data !== 'object') return '';
      for (const value of [data.description, data.message, data.errors]) {
        if (typeof value === 'string' && value.trim()) return string(value);
        if (value && typeof value === 'object') {
          const messages = Object.values(value).flat().filter((item) => typeof item === 'string');
          if (messages.length) return string(messages.join(' '));
        }
      }
      return '';
    }

    connectedCallback() {
      if (this.ready) return;
      this.events = new AbortController();
      const signal = this.events.signal;
      this.config = parse(this.querySelector('[data-nxs-config]')?.textContent || '{}', {});
      if (!this.config || typeof this.config !== 'object' || Array.isArray(this.config)) this.config = {};
      this.strings = this.config.strings && typeof this.config.strings === 'object' ? this.config.strings : {};
      this.cartUrl = url(this.config.cartUrl, 'cart');
      this.addUrl = url(this.config.addUrl, 'add');
      const currency = /^[A-Z]{3}$/.test(this.config.currency || '') ? this.config.currency : 'EUR';
      try { this.money = new Intl.NumberFormat(this.config.locale || 'de-DE', { style: 'currency', currency }); }
      catch { this.money = new Intl.NumberFormat('de-DE', { style: 'currency', currency }); }
      this.products = [];
      this.variants = new Map();
      this.choices = new Map();
      const seen = new Set();
      const rawProducts = parse(this.querySelector('[data-nxs-products]')?.textContent || '[]', []);
      for (const raw of Array.isArray(rawProducts) ? rawProducts : []) {
        if (!raw || typeof raw !== 'object') continue;
        const handle = string(raw.handle, 255);
        const title = string(raw.title, 500);
        const productUrl = url(raw.url);
        if (!handle || !title || !productUrl || seen.has(handle)) continue;
        const product = {
          handle, title, url: productUrl, image: url(raw.image, 'image'),
          categories: Array.isArray(raw.categories) ? raw.categories.filter((value) => typeof value === 'string').slice(0, 30) : [],
          defaultOnly: raw.defaultOnly === true,
          requiresSellingPlan: raw.requiresSellingPlan === true,
          variants: []
        };
        for (const value of Array.isArray(raw.variants) ? raw.variants : []) {
          if (!value || typeof value !== 'object') continue;
          const id = string(value.id, 30);
          if (!/^\d+$/.test(id) || this.variants.has(id) || !Number.isSafeInteger(value.price) || value.price < 0) continue;
          const variant = {
            id, title: string(value.title, 300), price: value.price, unitPriceLabel: string(value.unitPriceLabel, 150), available: value.available === true,
            min: value.min, max: value.max, increment: value.increment
          };
          product.variants.push(variant);
          this.variants.set(id, { product, variant });
        }
        if (!product.variants.length) continue;
        seen.add(handle);
        this.products.push(product);
        const first = product.variants.find((variant) => variant.available && NxtSetBuilder.quantityBounds(variant).max > 0) || product.variants[0];
        this.choices.set(handle, first.id);
      }
      this.productMap = new Map(this.products.map((product) => [product.handle, product]));
      this.selection = new Map();
      this.invalidQuantities = new Map();
      this.category = 'all';
      this.search = '';
      this.pending = false;
      this.uncertain = false;
      this.submitted = false;
      this.inspected = false;
      this.storageAvailable = true;
      this.dialog = this.querySelector('dialog[data-nxs-dialog]');
      this.grid = this.querySelector('[data-nxs-grid]');
      this.lines = this.querySelector('[data-nxs-selection]');
      this.status = this.querySelector('[data-nxs-status]');
      this.cartLink = this.querySelector('[data-nxs-cart-link]');
      if (!this.dialog || !this.grid || !this.lines || !this.cartUrl || !this.addUrl) return;
      if (this.cartLink) this.cartLink.href = this.cartUrl;
      this.restoreSelection();
      document.addEventListener('click', (event) => this.onClick(event), { signal });
      window.addEventListener('pageshow', (event) => {
        if (!event.persisted || this.pending) return;
        this.restoreSelection();
        this.renderGrid();
        this.renderSelection();
        this.sync();
      }, { signal });
      this.addEventListener('change', (event) => this.onChange(event), { signal });
      this.addEventListener('input', (event) => { if (event.target.matches('input[data-nxs-quantity]')) this.onChange(event); }, { signal });
      this.querySelector('[data-nxs-search]')?.addEventListener('input', (event) => {
        if (this.locked()) return;
        this.search = event.target.value;
        this.renderGrid();
      }, { signal });
      this.dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        if (!this.pending) this.dialog.close();
      }, { signal });
      this.dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('nxs-set-open');
        if (this.returnFocus?.isConnected) this.returnFocus.focus({ preventScroll: true });
      }, { signal });
      this.dialog.addEventListener('click', (event) => {
        if (this.pending || event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, { signal });
      this.ready = true;
      this.renderGrid();
      this.renderSelection();
      this.sync();
      document.documentElement.classList.add('nxs-set-ready');
    }

    disconnectedCallback() {
      this.events?.abort();
      if (this.dialog?.open && !this.pending) this.dialog.close();
      document.documentElement.classList.remove('nxs-set-open');
      if (!document.querySelector('nxt-set-builder')) document.documentElement.classList.remove('nxs-set-ready');
      this.ready = false;
    }

    text(key, values = {}) {
      const selectedKey = values.count === 1 && this.strings[`${key}_one`] ? `${key}_one` : key;
      return string(this.strings[selectedKey]).replace(/\{\{\s*(\w+)\s*\}\}/g, (_, name) => String(values[name] ?? ''))
        .replace(/__NXS_(TITLE|COUNT|MIN|MAX|STEP)__/g, (_, name) => String(values[name.toLowerCase()] ?? ''));
    }

    format(cents) { return this.money.format(cents / 100); }
    locked() { return this.pending || this.uncertain || this.submitted; }

    storageNotice() {
      const note = this.querySelector('[data-nxs-persistence-note]');
      if (note) note.textContent = this.text(this.storageAvailable ? 'persistence_hint' : 'persistence_unavailable');
    }

    persistSelection() {
      if (!this.storageAvailable) return;
      try {
        if (this.submitted || (!this.selection.size && !this.locked())) {
          window.sessionStorage.removeItem(NxtSetBuilder.storageKey);
        } else {
          const items = [...this.selection].map(([id, quantity]) => ({ id, quantity }));
          window.sessionStorage.setItem(NxtSetBuilder.storageKey, JSON.stringify({ version: 1, state: this.pending ? 'pending' : this.uncertain ? 'uncertain' : 'editing', inspected: this.inspected, items }));
        }
      } catch {
        this.storageAvailable = false;
        this.storageNotice();
      }
    }

    restoreSelection() {
      if (!this.storageAvailable) return;
      try {
        const restored = NxtSetBuilder.restore(window.sessionStorage.getItem(NxtSetBuilder.storageKey), this.variants);
        this.selection = restored.selection;
        this.invalidQuantities.clear();
        this.pending = false;
        this.submitted = false;
        this.uncertain = restored.uncertain;
        this.inspected = restored.inspected || (this.uncertain && this.config.pageType === 'cart');
        for (const [id] of this.selection) this.choices.set(this.variants.get(id).product.handle, id);
        if (this.cartLink) this.cartLink.hidden = !this.uncertain;
        const reconcileNote = this.querySelector('[data-nxs-reconcile-note]');
        if (reconcileNote) {
          reconcileNote.textContent = restored.pruned ? this.text('restore_updated') : '';
          reconcileNote.hidden = !restored.pruned;
        }
        this.announce(this.uncertain ? this.text('restore_uncertain') : restored.pruned ? this.text('restore_updated') : '');
        this.persistSelection();
      } catch {
        this.storageAvailable = false;
      }
      this.storageNotice();
    }

    clearSelection() {
      if (this.pending || this.submitted || (this.uncertain && !this.inspected)) return;
      this.selection.clear();
      this.invalidQuantities.clear();
      this.uncertain = false;
      this.inspected = false;
      if (this.cartLink) this.cartLink.hidden = true;
      const reconcileNote = this.querySelector('[data-nxs-reconcile-note]');
      if (reconcileNote) reconcileNote.hidden = true;
      this.persistSelection();
      this.renderSelection();
      this.sync();
      this.announce(this.text('empty_selection'));
    }

    productSelection(trigger) {
      const product = this.productMap.get(trigger.dataset.nxsProductHandle);
      if (!product) return { error: 'unavailable' };
      const namedForm = trigger.dataset.nxsFormId ? document.getElementById(trigger.dataset.nxsFormId) : null;
      const form = namedForm?.tagName === 'FORM' ? namedForm : trigger.closest('form') || trigger.closest('product-form-component')?.querySelector('form');
      const control = (name) => form?.elements?.namedItem(name);
      const id = form ? String(control('id')?.value || '') : string(trigger.dataset.nxsVariantId, 30);
      const entry = this.variants.get(id);
      if (!entry || entry.product.handle !== product.handle || !entry.variant.available) return { error: 'unavailable' };
      if (product.requiresSellingPlan || control('selling_plan')?.value) return { error: 'subscription_unavailable' };
      const quantityControl = control('quantity');
      const quantity = NxtSetBuilder.validQuantity(quantityControl ? quantityControl.value : NxtSetBuilder.quantityBounds(entry.variant).min, entry.variant);
      return quantity === null ? { error: 'quantity_error', entry } : { id, quantity };
    }

    addProduct(trigger) {
      this.open(trigger);
      if (this.locked()) return;
      const selected = this.productSelection(trigger);
      if (selected.error) {
        if (selected.entry) this.quantityError(selected.entry);
        else this.announce(this.text(selected.error));
        return;
      }
      if (this.addVariant(selected.id, selected.quantity)) {
        const summary = this.querySelector('[data-nxs-summary]');
        summary?.scrollIntoView({ block: 'nearest' });
        summary?.focus({ preventScroll: true });
      }
    }

    announce(message) {
      if (!this.status) return;
      this.status.textContent = message;
      this.status.hidden = !message;
      this.status.setAttribute('aria-live', 'polite');
      this.status.setAttribute('aria-atomic', 'true');
    }

    open(trigger) {
      if (!this.ready || this.dialog.open) return;
      this.returnFocus = trigger;
      this.dialog.showModal();
      document.documentElement.classList.add('nxs-set-open');
      const heading = this.dialog.querySelector('h2');
      if (heading) {
        heading.tabIndex = -1;
        heading.focus();
      }
    }

    onClick(event) {
      if (!(event.target instanceof Element)) return;
      const productTrigger = event.target.closest('button[data-nxs-product-add]');
      if (productTrigger) {
        event.preventDefault();
        if (!productTrigger.disabled) this.addProduct(productTrigger);
        return;
      }
      const trigger = event.target.closest('button[data-nxs-open]');
      if (trigger) {
        event.preventDefault();
        this.open(trigger);
        return;
      }
      if (!this.contains(event.target)) return;
      if (this.pending && event.target.closest('a')) {
        event.preventDefault();
        return;
      }
      const button = event.target.closest('button');
      if (!button || button.disabled) return;
      if (button.hasAttribute('data-nxs-close')) {
        event.preventDefault();
        if (!this.pending) this.dialog.close();
        return;
      }
      if (button.hasAttribute('data-nxs-submit')) {
        event.preventDefault();
        this.submit();
        return;
      }
      if (button.hasAttribute('data-nxs-clear')) {
        event.preventDefault();
        this.clearSelection();
        return;
      }
      if (this.locked()) return;
      if (button.hasAttribute('data-nxs-category')) {
        event.preventDefault();
        this.category = button.dataset.nxsCategory || 'all';
        this.renderGrid();
      } else if (button.hasAttribute('data-nxs-add')) {
        event.preventDefault();
        this.addVariant(this.choices.get(button.dataset.nxsAdd));
      } else if (button.hasAttribute('data-nxs-remove')) {
        event.preventDefault();
        this.selection.delete(button.dataset.nxsRemove);
        this.invalidQuantities.delete(button.dataset.nxsRemove);
        this.persistSelection();
        this.renderSelection();
        this.sync();
        this.announce(this.selection.size ? '' : this.text('empty_selection'));
        this.lines.querySelector('button')?.focus();
      } else if (button.hasAttribute('data-nxs-increase') || button.hasAttribute('data-nxs-decrease')) {
        event.preventDefault();
        const increase = button.hasAttribute('data-nxs-increase');
        const id = increase ? button.dataset.nxsIncrease : button.dataset.nxsDecrease;
        const entry = this.variants.get(id);
        if (!entry || !this.selection.has(id)) return;
        const { increment } = NxtSetBuilder.quantityBounds(entry.variant);
        this.setQuantity(id, this.selection.get(id) + increment * (increase ? 1 : -1), increase ? 'increase' : 'decrease');
      }
    }

    onChange(event) {
      if (this.locked() || !(event.target instanceof Element)) return;
      const target = event.target;
      if (target.matches('select[data-nxs-variant]')) {
        const product = this.productMap.get(target.dataset.nxsVariant);
        if (product?.variants.some((variant) => variant.id === target.value)) {
          this.choices.set(product.handle, target.value);
          this.sync();
        }
      } else if (target.matches('input[data-nxs-quantity]')) {
        this.setQuantity(target.dataset.nxsQuantity, target.value, 'quantity');
      }
    }

    addVariant(id, requestedQuantity) {
      if (this.locked()) return false;
      const entry = this.variants.get(id);
      if (!entry || !entry.variant.available || entry.product.requiresSellingPlan) return false;
      const { min, increment } = NxtSetBuilder.quantityBounds(entry.variant);
      if (requestedQuantity !== undefined && NxtSetBuilder.validQuantity(requestedQuantity, entry.variant) === null) {
        this.quantityError(entry);
        return false;
      }
      const quantity = requestedQuantity === undefined ? (this.selection.has(id) ? this.selection.get(id) + increment : min) : (this.selection.get(id) || 0) + requestedQuantity;
      if (NxtSetBuilder.validQuantity(quantity, entry.variant) === null) {
        this.quantityError(entry);
        return false;
      }
      this.selection.set(id, quantity);
      this.choices.set(entry.product.handle, id);
      this.invalidQuantities.delete(id);
      this.persistSelection();
      this.renderSelection();
      this.sync();
      this.announce(this.text('added', { title: entry.product.title }));
      return true;
    }

    quantityError(entry) {
      const { min, max, increment } = NxtSetBuilder.quantityBounds(entry.variant);
      this.announce(this.text('quantity_error', { title: entry.product.title, min, max, step: increment }));
    }

    setQuantity(id, value, focusAction) {
      if (this.locked() || !this.selection.has(id)) return;
      const entry = this.variants.get(id);
      if (!entry) return;
      const quantity = NxtSetBuilder.validQuantity(value, entry.variant);
      if (quantity === null) {
        this.invalidQuantities.set(id, String(value ?? ''));
        this.quantityError(entry);
      }
      else {
        this.selection.set(id, quantity);
        this.invalidQuantities.delete(id);
        this.persistSelection();
        this.announce('');
      }
      // Preserve the native input and caret while someone types on a phone.
      if (focusAction === 'quantity') {
        this.sync();
        return;
      }
      this.renderSelection();
      this.sync();
      const attribute = `data-nxs-${focusAction}`;
      const focus = [...this.lines.querySelectorAll(`[${attribute}]`)].find((element) => element.getAttribute(attribute) === id);
      if (focus && !focus.disabled) focus.focus({ preventScroll: true });
      else [...this.lines.querySelectorAll('[data-nxs-quantity]')].find((element) => element.dataset.nxsQuantity === id)?.focus({ preventScroll: true });
    }

    renderGrid() {
      const query = string(this.search).normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
      const products = this.products.filter((product) => {
        const searchable = `${product.title} ${product.variants.map((variant) => variant.title).join(' ')}`.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase();
        return (this.category === 'all' || product.categories.includes(this.category)) && (!query || searchable.includes(query));
      });
      this.grid.replaceChildren();
      const results = this.querySelector('[data-nxs-results]');
      if (results) results.textContent = this.text(products.length === 1 ? 'results_count_one' : 'results_count', { count: products.length });
      if (!products.length) this.grid.append(node('p', 'nxs-set-no-results', this.text('no_results')));
      for (const product of products) {
        const card = node('article', 'nxs-set-card');
        card.dataset.nxsCard = product.handle;
        const imageLink = node('a', 'nxs-set-card__image');
        imageLink.href = product.url;
        imageLink.tabIndex = -1;
        imageLink.setAttribute('aria-hidden', 'true');
        if (product.image) {
          const image = node('img');
          image.src = product.image;
          image.alt = '';
          image.width = 320;
          image.height = 320;
          image.loading = 'lazy';
          image.decoding = 'async';
          imageLink.append(image);
        }
        card.append(imageLink);
        const body = node('div', 'nxs-set-card__body');
        const heading = node('h3', 'nxs-set-card__title');
        const link = node('a', '', product.title);
        link.href = product.url;
        heading.append(link);
        body.append(heading);
        const price = node('p', 'nxs-set-card__price');
        price.setAttribute('data-nxs-card-price', '');
        body.append(price);
        const unitPrice = node('p', 'nxs-set-card__unit-price');
        unitPrice.setAttribute('data-nxs-card-unit-price', '');
        unitPrice.hidden = true;
        body.append(unitPrice);
        if (product.variants.length > 1) {
          const label = node('label', 'nxs-set-card__variant');
          label.append(node('span', '', this.text('select_variant')));
          const select = node('select');
          select.dataset.nxsVariant = product.handle;
          select.setAttribute('aria-label', this.text('variant', { title: product.title }));
          for (const variant of product.variants) {
            const option = node('option', '', `${variant.title}${variant.available ? '' : ` · ${this.text('sold_out')}`}`);
            option.value = variant.id;
            option.disabled = !variant.available || NxtSetBuilder.quantityBounds(variant).max === 0;
            select.append(option);
          }
          select.value = this.choices.get(product.handle);
          label.append(select);
          body.append(label);
        } else if (!product.defaultOnly && product.variants[0].title) {
          body.append(node('p', 'nxs-set-card__variant-name', product.variants[0].title));
        }
        const selected = node('p', 'nxs-set-card__selected');
        selected.setAttribute('data-nxs-card-selected', '');
        body.append(selected);
        const add = node('button', 'nxs-set-card__add');
        add.type = 'button';
        add.dataset.nxsAdd = product.handle;
        body.append(add);
        card.append(body);
        this.grid.append(card);
      }
      this.sync();
    }

    renderSelection() {
      this.lines.replaceChildren();
      for (const [id, quantity] of this.selection) {
        const { product, variant } = this.variants.get(id);
        const { min, max, increment } = NxtSetBuilder.quantityBounds(variant);
        const line = node('li', 'nxs-set-line');
        line.dataset.nxsLine = id;
        if (product.image) {
          const image = node('img', 'nxs-set-line__image');
          image.src = product.image;
          image.alt = '';
          image.width = 80;
          image.height = 80;
          image.loading = 'lazy';
          line.append(image);
        }
        const body = node('div', 'nxs-set-line__body');
        body.append(node('h3', 'nxs-set-line__title', product.title));
        if (!product.defaultOnly && variant.title) body.append(node('p', 'nxs-set-line__variant', variant.title));
        const price = node('p', 'nxs-set-line__price', this.format(variant.price * quantity));
        price.setAttribute('aria-label', `${this.text('price')}: ${this.format(variant.price * quantity)}`);
        body.append(price);
        if (variant.unitPriceLabel) body.append(node('p', 'nxs-set-line__unit-price', variant.unitPriceLabel));
        const controls = node('div', 'nxs-set-line__quantity');
        const decrease = node('button', 'nxs-set-line__step', '−');
        decrease.type = 'button';
        decrease.dataset.nxsDecrease = id;
        decrease.setAttribute('aria-label', this.text('decrease', { title: product.title }));
        decrease.disabled = quantity <= min || this.locked();
        const input = node('input');
        input.type = 'number';
        input.inputMode = 'numeric';
        input.min = String(min);
        input.max = String(max);
        input.step = String(increment);
        input.value = this.invalidQuantities.has(id) ? this.invalidQuantities.get(id) : String(quantity);
        input.dataset.nxsQuantity = id;
        input.setAttribute('aria-invalid', String(this.invalidQuantities.has(id)));
        input.setAttribute('aria-label', this.text('quantity', { title: product.title }));
        const increase = node('button', 'nxs-set-line__step', '+');
        increase.type = 'button';
        increase.dataset.nxsIncrease = id;
        increase.setAttribute('aria-label', this.text('increase', { title: product.title }));
        increase.disabled = quantity >= max || this.locked();
        controls.append(decrease, input, increase);
        body.append(controls);
        const remove = node('button', 'nxs-set-line__remove', this.text('remove_short'));
        remove.type = 'button';
        remove.dataset.nxsRemove = id;
        remove.setAttribute('aria-label', this.text('remove', { title: product.title }));
        body.append(remove);
        line.append(body);
        this.lines.append(line);
      }
      const empty = this.querySelector('[data-nxs-empty]');
      if (empty) empty.hidden = this.selection.size !== 0;
    }

    sync() {
      const locked = this.locked();
      this.classList.toggle('is-pending', this.pending);
      this.classList.toggle('is-uncertain', this.uncertain);
      this.setAttribute('aria-busy', String(this.pending));
      for (const input of this.querySelectorAll('input, select')) input.disabled = locked;
      for (const button of this.querySelectorAll('button')) {
        if (button.hasAttribute('data-nxs-close')) button.disabled = this.pending;
        else if (button.hasAttribute('data-nxs-submit')) button.disabled = locked || this.invalidQuantities.size > 0 || this.selection.size === 0 || NxtSetBuilder.total(this.selection, this.variants) === null;
        else button.disabled = locked;
      }
      for (const button of this.querySelectorAll('[data-nxs-category]')) button.setAttribute('aria-pressed', String(button.dataset.nxsCategory === this.category));
      for (const button of this.querySelectorAll('[data-nxs-clear]')) {
        button.disabled = this.pending || this.submitted || (this.uncertain ? !this.inspected : this.selection.size === 0);
        button.textContent = this.text(this.uncertain ? 'reset_after_inspection' : 'clear');
      }
      for (const card of this.grid.querySelectorAll('[data-nxs-card]')) {
        const product = this.productMap.get(card.dataset.nxsCard);
        const variant = this.variants.get(this.choices.get(product.handle))?.variant;
        if (!variant) continue;
        const { max } = NxtSetBuilder.quantityBounds(variant);
        const amount = product.variants.reduce((total, item) => total + (this.selection.get(item.id) || 0), 0);
        const price = card.querySelector('[data-nxs-card-price]');
        if (price) price.textContent = this.format(variant.price);
        const unitPrice = card.querySelector('[data-nxs-card-unit-price]');
        if (unitPrice) {
          unitPrice.textContent = variant.unitPriceLabel;
          unitPrice.hidden = !variant.unitPriceLabel;
        }
        const selected = card.querySelector('[data-nxs-card-selected]');
        if (selected) {
          selected.hidden = amount === 0;
          selected.textContent = this.text(amount === 1 ? 'selected_count_one' : 'selected_count', { count: amount });
        }
        card.classList.toggle('is-selected', amount > 0);
        const button = card.querySelector('[data-nxs-add]');
        if (button) {
          const unavailable = product.requiresSellingPlan || !variant.available || max === 0;
          button.disabled = locked || unavailable || (this.selection.get(variant.id) || 0) >= max;
          button.textContent = this.text(product.requiresSellingPlan ? 'subscription_unavailable' : !variant.available ? 'sold_out' : max === 0 ? 'unavailable' : 'add');
          button.setAttribute('aria-label', `${button.textContent}: ${product.title}`);
        }
      }
      for (const [id, quantity] of this.selection) {
        const { min, max } = NxtSetBuilder.quantityBounds(this.variants.get(id).variant);
        for (const button of this.lines.querySelectorAll('[data-nxs-decrease]')) if (button.dataset.nxsDecrease === id) button.disabled = locked || quantity <= min;
        for (const button of this.lines.querySelectorAll('[data-nxs-increase]')) if (button.dataset.nxsIncrease === id) button.disabled = locked || quantity >= max;
      }
      for (const line of this.lines.querySelectorAll('[data-nxs-line]')) {
        const id = line.dataset.nxsLine;
        const entry = this.variants.get(id);
        const quantity = this.selection.get(id);
        if (!entry || !quantity) continue;
        const price = line.querySelector('.nxs-set-line__price');
        if (price) {
          price.textContent = this.format(entry.variant.price * quantity);
          price.setAttribute('aria-label', `${this.text('price')}: ${price.textContent}`);
        }
        line.querySelector('[data-nxs-quantity]')?.setAttribute('aria-invalid', String(this.invalidQuantities.has(id)));
      }
      const total = NxtSetBuilder.total(this.selection, this.variants);
      const totalLabel = this.querySelector('[data-nxs-total]');
      if (totalLabel) totalLabel.textContent = total === null ? '—' : this.format(total);
      const count = [...this.selection.values()].reduce((sum, quantity) => sum + quantity, 0);
      for (const label of this.querySelectorAll('[data-nxs-count]')) label.textContent = this.text(count === 1 ? 'selected_count_one' : 'selected_count', { count });
      const submit = this.querySelector('[data-nxs-submit]');
      if (submit && this.pending) {
        if (!this.submitLabel) this.submitLabel = submit.textContent;
        submit.textContent = this.text('adding');
      } else if (submit && this.submitLabel) submit.textContent = this.submitLabel;
    }

    async submit() {
      if (this.locked()) return;
      if (this.invalidQuantities.size > 0) {
        const id = this.invalidQuantities.keys().next().value;
        this.quantityError(this.variants.get(id));
        return;
      }
      const payload = NxtSetBuilder.payload(this.selection, this.variants);
      if (!payload || NxtSetBuilder.total(this.selection, this.variants) === null) {
        this.announce(this.text('empty_selection'));
        return;
      }
      this.pending = true;
      this.inspected = false;
      this.persistSelection();
      this.sync();
      this.announce(this.text('adding'));
      if (this.cartLink) this.cartLink.hidden = true;
      const request = new AbortController();
      const timeout = setTimeout(() => request.abort(), 20000);
      try {
        const response = await fetch(this.addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          redirect: 'error',
          signal: request.signal,
          body: JSON.stringify(payload)
        });
        if (!response.ok) {
          let data = null;
          try { data = await response.json(); } catch {}
          this.uncertain = true;
          const description = NxtSetBuilder.errorDescription(data) || this.text('add_error');
          this.announce(`${description} ${this.text('inspect_cart')}`);
          if (this.cartLink) this.cartLink.hidden = false;
          return;
        }
        this.submitted = true;
        this.selection.clear();
        this.invalidQuantities.clear();
        this.persistSelection();
        this.announce(this.text('success'));
        if (this.cartLink) this.cartLink.hidden = false;
        window.location.assign(this.cartUrl);
      } catch {
        this.uncertain = true;
        this.announce(`${this.text('uncertain_error')} ${this.text('inspect_cart')}`);
        if (this.cartLink) this.cartLink.hidden = false;
      } finally {
        clearTimeout(timeout);
        this.pending = false;
        this.persistSelection();
        this.sync();
      }
    }
  }

  customElements.define('nxt-set-builder', NxtSetBuilder);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nxt-shopping-tools"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('nxt-shop-tools')) return;

  const safeText = (value, max = 1000) => typeof value === 'string' ? value.slice(0, max) : '';
  const parseJSON = (value, fallback) => {
    try { return JSON.parse(value); } catch { return fallback; }
  };
  const fill = (value, variables = {}) => safeText(value).replace(/\{\{\s*(\w+)\s*\}\}/g, (_, name) => String(variables[name] ?? '')).replace(/__NXT_(TITLE|COUNT|CURRENT|TOTAL)__/g, (_, name) => String(variables[name.toLowerCase()] ?? ''));
  const make = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };
  const safeURL = (value, image = false) => {
    if (typeof value !== 'string' || !value) return '';
    try {
      const url = new URL(value, location.href);
      if (!['https:', 'http:'].includes(url.protocol) || url.username || url.password) return '';
      if (image) {
        const shopifyCDN = url.hostname === 'cdn.shopify.com' || url.hostname === 'shopifycdn.com' || url.hostname.endsWith('.shopifycdn.com');
        if (url.origin !== location.origin && !(url.protocol === 'https:' && shopifyCDN)) return '';
      } else if (url.origin !== location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[a-z0-9_-]+\/?$/i.test(url.pathname)) {
        return '';
      }
      return url.href;
    } catch { return ''; }
  };

  class NxtShopTools extends HTMLElement {
    static filterProducts(products, filters = {}) {
      const category = filters.category || 'all';
      const form = filters.form || 'all';
      const budgetValue = filters.budget;
      const budget = budgetValue === 'all' || budgetValue === '' || budgetValue == null ? Infinity : Number(budgetValue);
      const maximum = Number.isFinite(budget) && budget >= 0 ? budget : Infinity;
      return products.filter((product) =>
        (category === 'all' || product.categories.includes(category)) &&
        (form === 'all' || product.form === form) &&
        product.price <= maximum
      ).sort((a, b) => Number(b.available) - Number(a.available));
    }

    connectedCallback() {
      if (this._connected) return;
      this._connected = true;
      this._events = new AbortController();
      const signal = this._events.signal;
      this.strings = parseJSON(this.querySelector('script[data-nxt-strings]')?.textContent || '{}', {});
      if (!this.strings || typeof this.strings !== 'object' || Array.isArray(this.strings)) this.strings = {};
      const rawProducts = parseJSON(this.querySelector('script[data-nxt-products]')?.textContent || '[]', []);
      this.products = [];
      const seen = new Set();
      if (Array.isArray(rawProducts)) {
        for (const item of rawProducts) {
          if (!item || typeof item !== 'object') continue;
          const handle = safeText(item.handle, 255);
          const title = safeText(item.title, 500);
          const url = safeURL(item.url);
          if (!handle || !title || !url || seen.has(handle) || !Number.isSafeInteger(item.price) || item.price < 0) continue;
          seen.add(handle);
          this.products.push({
            handle, title, url,
            image: safeURL(item.image, true),
            price: item.price,
            priceLabel: safeText(item.priceLabel, 100),
            unitPriceLabel: safeText(item.unitPriceLabel, 150),
            category: safeText(item.category, 150),
            categories: Array.isArray(item.categories) ? item.categories.filter((value) => typeof value === 'string').slice(0, 30) : [],
            form: ['powder', 'capsules', 'gummies', 'shots', 'other'].includes(item.form) ? item.form : 'other',
            formLabel: safeText(item.formLabel, 100),
            available: item.available === true
          });
        }
      }
      this.dialogs = new Map([...this.querySelectorAll('dialog[data-nxt-dialog]')].map((dialog) => [dialog.dataset.nxtDialog, dialog]));
      this.form = this.querySelector('[data-nxt-finder-form]');
      this.step = 0;
      this.finderComplete = false;
      this.activeDialog = null;
      this.returnFocus = null;
      this.status = document.querySelector('[data-nxt-status]');
      this.statusParent = this.status?.parentNode;
      this.statusNext = this.status?.nextSibling;
      document.addEventListener('click', (event) => this.onClick(event), { signal });
      for (const dialog of this.dialogs.values()) {
        dialog.addEventListener('close', () => this.afterClose(dialog), { signal });
        dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          dialog.close();
        }, { signal });
        dialog.addEventListener('click', (event) => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        }, { signal });
      }
      this.form?.addEventListener('submit', (event) => {
        event.preventDefault();
        if (this.step < 2) this.showStep(this.step + 1, true);
        else this.showFinderResults();
      }, { signal });
      this.showStep(0);
      document.documentElement.classList.add('nxt-tools-ready');
    }

    disconnectedCallback() {
      this._events?.abort();
      clearTimeout(this.statusTimer);
      clearTimeout(this.statusClearTimer);
      this.restoreStatus();
      for (const dialog of this.dialogs?.values() || []) if (dialog.open) dialog.close();
      document.documentElement.classList.remove('nxt-tool-dialog-open');
      this._connected = false;
      if (!document.querySelector('nxt-shop-tools')) document.documentElement.classList.remove('nxt-tools-ready');
    }

    text(key, variables) {
      const selectedKey = key === 'results_count' && variables?.count === 1 && this.strings.results_count_one ? 'results_count_one' : key;
      return fill(this.strings[selectedKey], variables);
    }

    announce(key, variables) {
      const status = this.status;
      if (!status) return;
      if (this.activeDialog?.open) this.activeDialog.append(status);
      else this.restoreStatus();
      clearTimeout(this.statusTimer);
      clearTimeout(this.statusClearTimer);
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      status.setAttribute('aria-atomic', 'true');
      status.textContent = '';
      status.hidden = false;
      status.classList.remove('is-visible');
      this.statusTimer = setTimeout(() => {
        status.textContent = this.text(key, variables);
        status.classList.add('is-visible');
        this.statusClearTimer = setTimeout(() => {
          status.classList.remove('is-visible');
          status.hidden = true;
        }, 4500);
      }, 30);
    }

    restoreStatus() {
      if (!this.status || !this.statusParent) return;
      if (this.statusNext?.parentNode === this.statusParent) this.statusParent.insertBefore(this.status, this.statusNext);
      else this.statusParent.append(this.status);
    }

    onClick(event) {
      if (!(event.target instanceof Element)) return;
      const button = event.target.closest('button');
      if (!button || button.disabled) return;
      if (button.dataset.nxtOpen === 'finder') {
        event.preventDefault();
        this.openDialog(button.dataset.nxtOpen, button);
      } else if (this.contains(button)) {
        if (button.hasAttribute('data-nxt-close')) {
          event.preventDefault();
          button.closest('dialog')?.close();
        } else if (button.hasAttribute('data-nxt-next')) {
          event.preventDefault();
          this.showStep(this.step + 1, true);
        } else if (button.hasAttribute('data-nxt-back')) {
          event.preventDefault();
          this.showStep(this.step - 1, true);
        } else if (button.hasAttribute('data-nxt-reset')) {
          event.preventDefault();
          this.form?.reset();
          this.finderComplete = false;
          this.showStep(0, true);
        }
      }
    }

    openDialog(kind, trigger) {
      const dialog = this.dialogs.get(kind);
      if (!dialog || typeof dialog.showModal !== 'function') return;
      if (this.activeDialog === dialog && dialog.open) return;
      const wasInsideDialog = this.activeDialog?.contains(trigger);
      const previousReturnFocus = this.returnFocus;
      this.activeDialog = dialog;
      this.returnFocus = wasInsideDialog && previousReturnFocus?.isConnected ? previousReturnFocus : trigger;
      for (const existing of this.dialogs.values()) if (existing !== dialog && existing.open) existing.close();
      dialog.showModal();
      document.documentElement.classList.add('nxt-tool-dialog-open');
      this.focusDialogHeading(dialog);
    }

    afterClose(dialog) {
      if (this.activeDialog !== dialog || dialog.open) return;
      this.activeDialog = null;
      document.documentElement.classList.remove('nxt-tool-dialog-open');
      this.restoreStatus();
      const target = this.returnFocus;
      this.returnFocus = null;
      if (target?.isConnected) target.focus({ preventScroll: true });
    }

    focusDialogHeading(dialog) {
      if (!dialog) return;
      const heading = dialog.querySelector('[data-nxt-dialog-heading], h2');
      if (heading) {
        heading.setAttribute('tabindex', '-1');
        heading.focus();
      }
    }

    productCard(product) {
      const card = make('article', 'nxt-tool-card');
      card.dataset.nxtProduct = product.handle;
      const imageLink = make('a', 'nxt-tool-card__image');
      imageLink.href = product.url;
      imageLink.tabIndex = -1;
      imageLink.setAttribute('aria-hidden', 'true');
      if (product.image) {
        const img = make('img');
        img.src = product.image;
        img.alt = '';
        img.width = 360;
        img.height = 360;
        img.loading = 'lazy';
        img.decoding = 'async';
        imageLink.append(img);
      }
      card.append(imageLink);
      const body = make('div', 'nxt-tool-card__body');
      const heading = make('h3', 'nxt-tool-card__title');
      const link = make('a', '', product.title);
      link.href = product.url;
      heading.append(link);
      body.append(heading);
      body.append(make('p', 'nxt-tool-card__form', product.formLabel || this.text('not_provided')));
      body.append(make('p', 'nxt-tool-card__price', product.priceLabel || this.text('not_provided')));
      if (product.unitPriceLabel) body.append(make('p', 'nxt-tool-card__unit', product.unitPriceLabel));
      const availability = make('p', 'nxt-tool-card__availability', this.text(product.available ? 'in_stock' : 'sold_out'));
      availability.classList.toggle('is-sold-out', !product.available);
      body.append(availability);
      const view = make('a', 'nxt-tool-card__view', this.text('view_product'));
      view.href = product.url;
      view.setAttribute('aria-label', `${this.text('view_product')}: ${product.title}`);
      body.append(view);
      card.append(body);
      return card;
    }

    showStep(next, focus = false) {
      if (!this.form) return;
      this.step = Math.max(0, Math.min(2, next));
      const questions = this.querySelector('[data-nxt-finder-questions]');
      const output = this.querySelector('[data-nxt-finder-output]');
      if (questions) questions.hidden = false;
      if (output) output.hidden = true;
      for (const fieldset of this.form.querySelectorAll('[data-nxt-step]')) {
        fieldset.hidden = Number(fieldset.dataset.nxtStep) !== this.step;
      }
      for (const button of this.form.querySelectorAll('[data-nxt-back]')) button.hidden = this.step === 0;
      for (const button of this.form.querySelectorAll('[data-nxt-next]')) button.hidden = this.step === 2;
      for (const button of this.form.querySelectorAll('[data-nxt-submit], [type="submit"]')) button.hidden = this.step !== 2;
      const stepLabel = this.querySelector('[data-nxt-step-label]');
      if (stepLabel) stepLabel.textContent = this.text('step_label', { current: this.step + 1, total: 3 });
      const progress = this.querySelector('[data-nxt-finder-progress]');
      if (progress) {
        progress.max = 3;
        progress.value = this.step + 1;
        progress.textContent = `${this.step + 1}/3`;
        progress.setAttribute('aria-label', this.text('step_label', { current: this.step + 1, total: 3 }));
      }
      if (focus) {
        const fieldset = this.form.querySelector(`[data-nxt-step="${this.step}"]`);
        const heading = fieldset?.querySelector('h3, legend');
        if (heading) {
          heading.setAttribute('tabindex', '-1');
          heading.focus();
        } else fieldset?.querySelector('input')?.focus();
      }
    }

    showFinderResults() {
      const results = this.querySelector('[data-nxt-finder-results]');
      if (!this.form || !results) return;
      const formData = new FormData(this.form);
      const products = NxtShopTools.filterProducts(this.products, {
        category: formData.get('category'),
        form: formData.get('form'),
        budget: formData.get('budget')
      });
      results.replaceChildren();
      const countKey = products.length === 1 ? 'results_count_one' : 'results_count';
      const count = make('p', 'nxt-tool-results-count', this.text(countKey, { count: products.length }));
      results.append(count);
      if (products.length) {
        const grid = make('div', 'nxt-tool-grid');
        for (const product of products) grid.append(this.productCard(product));
        results.append(grid);
      } else results.append(make('p', 'nxt-tool-empty', this.text('no_results')));
      const questions = this.querySelector('[data-nxt-finder-questions]');
      const output = this.querySelector('[data-nxt-finder-output]');
      if (questions) questions.hidden = true;
      if (output) output.hidden = false;
      this.finderComplete = true;
      const heading = this.querySelector('[data-nxt-results-heading]');
      if (heading) {
        heading.textContent = this.text('results_title');
        heading.setAttribute('tabindex', '-1');
        heading.focus();
      }
      this.announce(countKey, { count: products.length });
    }
  }

  customElements.define('nxt-shop-tools', NxtShopTools);
})();
  } catch(e) { console.error(e); }
})();

})();
